
export const TranslationVarProps = {
    OTHER: '{Other}',
    TERMS: '{termsValue}',
    PRIVACY: '{privacyValue}',
};

const translationIds = {
    /* DYNAMIC ELEMENTS */
    
    // DYNAMIC "{calapp, select, outlook {{calappname} or newer} ics_other {Other} other {{calappname}} }"
    CALENDAR_APP_NAME: 'sync.containers.calendar.app.name', 

    // DYNAMIC  "უზრუნველყოფილია ECAL-ის მიერ, ვეთანხმები {termsValue}-სა და {privacyValue}-ს."
    CALENDAR_FOOTER: 'sync.containers.calendar.calendar_service.footer', 
    
    // DYNAMIC "უბრალოდ {  calapp, select,    macChrome {      დააწკაპუნეთ \"Open Calendar\" და მიჰყევით ინსტრუქციას თქვენი სინქრონიზაციის დასასრულებლად.    }    macSafari {      დააწკაპუნეთ \"გახსენით კალენდარი\" და მიჰყევით ინსტრუქციებს თქვენი სინქრონიზაციის დასასრულებლად.    }    macFirefox {      დააწკაპუნეთ \" გახსენით ბმული\" თქვენი კალენდრის აპის გასახსნელად და მიჰყევით ინსტრუქციებს თქვენი სინქრონიზაციის დასასრულებლად.    }    macOther {      დააწკაპუნეთ \"გახსენით Calendar\" თქვენი კალენდრის აპის გასახსნელად და მიჰყევით ინსტრუქციებს თქვენი სინქრონიზაციის დასასრულებლად.    }    iosSafari {      შეეხეთ \" გახსენით Calendar\" და მიჰყევით ინსტრუქციას თქვენი სინქრონიზაციის დასასრულებლად.    }    iosChrome {      შეეხეთ \"გამოწერა\" და მიჰყევით ინსტრუქციებს თქვენი სინქრონიზაციის დასასრულებლად. სინქრონიზაცია.    }    iosOther {      tap \"Subscribe\" and follow the instructions, to complete your sync.    }    windowsChrome {      დააწკაპუნეთ \"გახსენით Microsoft Outlook\", მიჰყევით ინსტრუქციას და დააწკაპუნეთ    }    windowsFirefox {      დააწკაპუნეთ \"გახსენით ბმული\" Microsoft Outlook-ის გასახსნელად, მიჰყევით ინსტრუქციას და დააწკაპუნეთ <b>\"გაგზავნა/მიღება\"</b> თქვენი სინქრონიზაციის დასასრულებლად.    }    windowsEdge {      დააწკაპუნეთ \"დიახ\" Microsoft Outlook-ის გასახსნელად, მიჰყევით ინსტრუქციას და დააწკაპუნეთ <b>\"გაგზავნა/მიღება\"</b> თქვენი სინქრონიზაციის დასასრულებლად.    }    windowsIe {      დააწკაპუნეთ \"დაშვება\" Microsoft Outlook-ის გასახსნელად, მიჰყევით ინსტრუქციას და დააწკაპუნეთ <b>\"გაგზავნა/მიღება\"</b> თქვენი სინქრონიზაციის დასასრულებლად.    }    windowsOther {      დააწკაპუნეთ \"Ok\" Microsoft-ის გასახსნელად Outlook, მიჰყევით ინსტრუქციებს და დააწკაპუნეთ <b>\"გაგზავნა/მიღება\"</b> თქვენი სინქრონიზაციის დასასრულებლად.    }    other {      დააწკაპუნეთ \"Ok\", მიჰყევით ინსტრუქციებს თქვენი სინქრონიზაციის დასასრულებლად.    }}"
    CALENDAR_PROC_INSTRUCTIONS: 'sync.containers.calendar.proc.instruction', 
    
    // DYNAMIC "Simply click open {calendar} and paste the copied link into the field as shown above."
    SYMPLY_CLICK_PROC: 'sync.containers.calendar.proc.simply_click_calendar',

    // "{count, plural, =0{განრიგის სინქრონიზაცია} =1{სინქრონიზაცია # განრიგის} other{# განრიგის სინქრონიზაცია}}"
    SCHEDULE_SYNC_SCHEDULES: 'sync.containers.schedule.schedules.sync_schedules',

    // "{  calapp, select,     google {{calappname} Calendar}    apple {{calappname} Calendar}    windowslive {{calappname}}    outlook {{calappname} or newer}    hotmail {{calappname}}    office365 {{calappname} Calendar}    other {Other ICS Calendar}}"
    ACTIVE_CALENDAR_APP_NAME: 'sync.containers.user.active.calendar.app.name',

    // "{count, plural, one {კალენდარი უკვე გამოყენებულია} "
    ACTIVE_SUBTITLE: 'sync.containers.user.active.subtitle',

    
    // "მიმდინარეობს {calendar}-თან დაკავშირება"
    USER_CONNECTING_TO_CALENDAR: 'sync.containers.user.connecting_to_calendar',
    

    // "{  calapp, select,    other       {დამატებულია თქვენს კალენდარში}    google      {დამატებულია თქვენს {calappname} კალენდარში}    apple       {დამატებულია თქვენს {calappname} კალენდარში}    hotmail     {დამატებულია თქვენს {calappname} კალენდარში}    office365   {დამატებულია თქვენს {calappname} calendar}    windowslive {დამატებულია თქვენს {calappname} კალენდარში}    outlook     {დამატებულია თქვენს {calappname} ან უფრო ახალში}}"
    SUCCESS_PAGE_SUCCESS_INFO_SUBTITLE: 'sync.containers.user.success_page.success_info_subtitle',

    // "შენი {calendar} მალე გაიხსნება"
    USER_WAITING_FOR_CALENDAR: 'sync.containers.user.waiting_for_calendar',

    // DYNAMIC "{label} სავალდებულოა"
    REGISTRATION_REQUIRED_FIELD: 'sync.containers.user.registration.required.field', 

    // DYNAMIC "აუცილებელია იყო {requiredAge}-ზე მეტი"
    REGISTRATION_VALID_REQUIRED_AGE_NUMBER: 'sync.containers.user.registration.valid.requiredAgeNumber', 

    /* NON DYNAMIC ELEMENTS */

    COMPONENT_INFO: 'sync.components.app.progress_indicator.info',
    COMPONENT_SUB_INFO: 'sync.components.app.progress_indicator.sub_info',
    COMPONENT_BACK: 'sync.components.back',
    COMPONENT_CONTINUE: 'sync.components.continue',
    COMPONENT_COUNTRY: 'sync.components.country',
    COMPONENT_DAY: 'sync.components.day',
    COMPONENT_MONTH: 'sync.components.month',
    COMPONENT_YEAR: 'sync.components.year',
    COMPONENT_LOADING: 'sync.components.loading',
    COMPONENT_NEXT: 'sync.components.next',
    COMPONENT_OOPS: 'sync.components.oops',
    COMPONENT_OR: 'sync.components.or',
    COMPONENT_PHONE_NUMBER: 'sync.components.phoneNumber',
    COMPONENT_PLEASE_SELECT: 'sync.components.please_select',
    COMPONENT_PRIVACY_TEXT: 'sync.components.privacy_text',
    COMPONENT_SEND: 'sync.components.send',
    COMPONENT_SENDING: 'sync.components.sending',
    COMPONENT_SENT: 'sync.components.sent',
    COMPONENT_SHARE: 'sync.components.share',
    COMPONENT_SUCCESS: 'sync.components.success',
    COMPONENT_PROGRESS_INDICATOR_INFO: 'sync.components.user.progress_indicator.info',
    COMPONENT_WHOA: 'sync.components.whoa',
    
    COMPONENT_FEMALE: 'sync.components.female',
    COMPONENT_MALE: 'sync.components.male',
    COMPONENT_GENDER_NON_BINARY: 'sync.components.nonbinary',
    COMPONENT_GENDER_NOT_TO_DISCLOSE: 'sync.components.pntd',
    COMPONENT_MONTH_JAN: 'sync.components.month.jan',
    COMPONENT_MONTH_FEB: 'sync.components.month.feb',
    COMPONENT_MONTH_MAR: 'sync.components.month.mar',
    COMPONENT_MONTH_APR: 'sync.components.month.apr',
    COMPONENT_MONTH_MAY: 'sync.components.month.may',
    COMPONENT_MONTH_JUN: 'sync.components.month.jun',
    COMPONENT_MONTH_JUL: 'sync.components.month.jul',
    COMPONENT_MONTH_AUG: 'sync.components.month.aug',
    COMPONENT_MONTH_SEP: 'sync.components.month.sep',
    COMPONENT_MONTH_OCT: 'sync.components.month.oct',
    COMPONENT_MONTH_NOV: 'sync.components.month.nov',
    COMPONENT_MONTH_DEC: 'sync.components.month.dec',
 
    CALENDAR_HEADER: 'sync.containers.calendar.header',
    COPY_LINK: 'sync.containers.calendar.othercal.copylink',
    COPY_THIS_LINK: 'sync.containers.calendar.othercal.copythislink',
    OTHER_CALENDAR_INSTRUCTIONS: 'sync.containers.calendar.othercal.instructions',
    PRIVACY_FOOTER: 'sync.containers.calendar.privacy.footer',
    CALENDAR_PROC_CLICK_HERE: 'sync.containers.calendar.proc.clickhere',
    CALENDAR_PROC_GUIDE: 'sync.containers.calendar.proc.guide',
    CALENDAR_PROC_INFO: 'sync.containers.calendar.proc.info',
    CALENDAR_PROC_USE_DIFF_CAL: 'sync.containers.calendar.proc.instruction.usediffcal',
    CALENDAR_PROC_NEED_HELP: 'sync.containers.calendar.proc.needhelp',
    CALENDAR_PROC_SPINNER: 'sync.containers.calendar.proc.spinner',
    CALENDAR_PROC_TITLE: 'sync.containers.calendar.proc.title',

    CALENDAR_REPROC_INFO: 'sync.containers.calendar.reproc.info',

    CALENDAR_REPROC_TITLE: 'sync.containers.calendar.reproc.title',
    CALENDAR_REPROC_TRY_AGAIN :'sync.containers.calendar.reproc.tryagain',

    CALENDAR_SEND_TO_PHOHE_HEADER: 'sync.containers.calendar.send_to_phone.header',
    CALENDAR_SMS_CLICK_HERE_RESEND: 'sync.containers.calendar.sms.click_here_resend',
    CALENDAR_SMS_CONFIRMATION: 'sync.containers.calendar.sms.confirmation',
    CALENDAR_TERM_FOOTER: 'sync.containers.calendar.term.footer',

    CALENDAR_GUIDE_ADD_CALENDAR: 'sync.containers.calendar.guide.add_calendar',
    CALENDAR_GUIDE_SUBSCRIBE_FROM_WEB: 'sync.containers.calendar.guide.subscribe_from_web',
    CALENDAR_GUIDE_IMPORT: 'sync.containers.calendar.guide.import',
    CALENDAR_GUIDE_NEXT: 'sync.containers.calendar.guide.next', // this is different from 'Next' because it has '' quotes with in it.
    CALENDAR_GUIDE_ADD_CALENDAR_POPUP: 'sync.containers.calendar.guide.add_calendar_popup',
    CALENDAR_GUIDE_COPIED: 'sync.containers.calendar.guide.copied',
    CALENDAR_GUIDE_COPY: 'sync.containers.calendar.guide.copy',
    CALENDAR_GUIDE_COPY_THE_LINK: 'sync.containers.calendar.guide.copy_the_link_below',
    CALENDAR_GUIDE_FOLLOW_THESE_STEPS: 'sync.containers.calendar.guide.follow_these_steps',
    CALENDAR_GUIDE_OPEN_OUTLOOK_ON_DESKTOP: 'sync.containers.calendar.guide.open_outlook_on_desktop',
    CALENDAR_GUIDE_PASTE_THE_LINK: 'sync.containers.calendar.guide.paste_the_link',
    CALENDAR_GUIDE_SELECT_CALENDAR_OPTION: 'sync.containers.calendar.guide.select_calendar_option',
    CALENDAR_GUIDE_STEP: 'sync.containers.calendar.guide.step',


    SCHEDULE_CATEGORY_ALL_SCHEDULES: 'sync.containers.schedule.category.all_schedules',
    SCHEDULE_CATEGORY_BROWSE: 'sync.containers.schedule.category.browse',
    SCHEDULE_HEADER: 'sync.containers.schedule.header',
    SCHEDULE_HEADING_TEXT: 'sync.containers.schedule.heading_text',
    
    USER_INFO_CAL_APP: 'sync.containers.user.active.info-cal-app',
    USER_INFO_CALL_APP_SELECT: 'sync.containers.user.active.info-cal-app.select',
    USER_ACTIVE_TITLE: 'sync.containers.user.active.title',
    USER_CLICK_HERE_TO_LOGIN: 'sync.containers.user.click_here_to_login',
    
    USER_NOTHING_HAPPENED: 'sync.containers.user.nothing_happened',
    USER_SOMETHING_WENT_WRONG: 'sync.containers.user.oops_page.something_went_wrong',
    USER_OOPS_PAGE_TECH_PROB: 'sync.containers.user.oops_page.we_are_sorry_tech_prob',
    USER_PLEASE_LOGIN: 'sync.containers.user.please_login_to_calendar',

    REGISTRATION_CONFIRM_DETAILS:'sync.containers.user.registration.confirm_your_details',
    REGISTRATION_INPUT_PLACEHOLDER: 'sync.containers.user.registration.input_placeholder.field',
    REGISTRATION_LABEL_AGE_GROUP: 'sync.containers.user.registration.label.age_group',
    REGISTRATION_LABEL_DOB: 'sync.containers.user.registration.label.dateOfBirth',
    REGISTRATION_LABEL_EMAIL: 'sync.containers.user.registration.label.email',
    REGISTRATION_LABEL_FIRSTNAME: 'sync.containers.user.registration.label.first_name',
    REGISTRATION_LABEL_LASTNAME: 'sync.containers.user.registration.label.last_name',
    REGISTRATION_LABEL_GENDER: 'sync.containers.user.registration.label.gender',
    REGISTRATION_LABEL_MOBILE: 'sync.containers.user.registration.label.mobile',
    REGISTRATION_LABEL_PARENT_EMAIL: 'sync.containers.user.registration.label.parent-email',
    REGISTRATION_LABEL_ZIP: 'sync.containers.user.registration.label.zip',
    REGISTRATION_NO: 'sync.containers.user.registration.no',
    REGISTRATION_YES: 'sync.containers.user.registration.yes',

    REGISTRATION_REQUIRED_DOB: 'sync.containers.user.registration.required.DOB',
    REGISTRATION_REQUIRED_AGE_GROUP: 'sync.containers.user.registration.required.age_group',
    REGISTRATION_REQUIRED_COUNTRY: 'sync.containers.user.registration.required.country',
    REGISTRATION_REQUIRED_EMAIL: 'sync.containers.user.registration.required.email',

    REGISTRATION_REQUIRED_FIRSTNAME: 'sync.containers.user.registration.required.first_name',
    REGISTRATION_REQUIRED_LASTNAME: 'sync.containers.user.registration.required.last_name',
    REGISTRATION_REQUIRED_MOBILE: 'sync.containers.user.registration.required.mobile',
    REGISTRATION_REQUIRED_PARENT_EMAIL: 'sync.containers.user.registration.required.parent-email',
    REGISTRATION_REQUIRED_ZIP: 'sync.containers.user.registration.required.zip',
    REGISTRATION_REQUIRED_GENDER: 'sync.containers.user.registration.required.gender',

    REGISTRATION_SELECT: 'sync.containers.user.registration.select',
    REGISTRATION_VALID_EMAIL: 'sync.containers.user.registration.valid.email',
    REGISTRATION_VALID_MOBILE: 'sync.containers.user.registration.valid.mobile',
    REGISTRATION_VALID_PARENT_EMAIL: 'sync.containers.user.registration.valid.parent-email',
    REGISTRATION_VALID_PARENT_CONSENT: 'sync.containers.user.registration.valid.parentConsent',
    REGISTRATION_VALID_PARENT_CONSENT_LABEL: 'sync.containers.user.registration.valid.parentConsentLabel',

    SUCCESS_PAGE_CHANGE_THIS: 'sync.containers.user.success_page.change_this',
    SUCCESS_PAGE_CLICK_HERE: 'sync.containers.user.success_page.click_here',
    SUCCESS_PAGE_COULD_NOT_FIND: 'sync.containers.user.success_page.could_not_find',
    SUCCESS_PAGE_DID_NOT_SEE: 'sync.containers.user.success_page.did_not_see_popup',
    SUCCESS_PAGE_EVENT_NOT_FOUND: 'sync.containers.user.success_page.event_not_found',
    SUCCESS_PAGE_SUCCESS_INFO_BODY: 'sync.containers.user.success_page.success_info_body',

    LINK_MUST_INCLUDE_WEBCAL_PROC: 'sync.containers.calendar.proc.link_must_include_webcal',

    CALENDAR_ALERT_INFO_TITLE: 'sync.containers.calendar.alertInfo.title',
    CALENDAR_ALERT_INFO_CONTENT: 'sync.containers.calendar.alertInfo.content',
    ERROR_DISPLAY_NOT_FOUND_TITLE: 'sync.containers.error.display_not_found.title',
    ERROR_DISPLAY_NOT_FOUND_DESCRIPTION: 'sync.containers.error.display_not_found.description',
    ERROR_API_UNAVAILABLE_TITLE: 'sync.containers.error.api_unavailable.title',
    ERROR_API_UNAVAILABLE_DESCRIPTION: 'sync.containers.error.api_unavailable.description',
    ERROR_DISPLAY_UNAVAILABLE_TITLE: 'sync.containers.error.display_unavailable.title',
    ERROR_DISPLAY_UNAVAILABLE_DESCRIPTION: 'sync.containers.error.display_unavailable.description',

    CALENDAR_GUIDE_OUTLOOK_DESKTOP_SUBTITLE: 'sync.containers.calendar.guide.outlook_desktop_subtitle',
    CALENDAR_GUIDE_WEBCAL_WARNING_TITLE: 'sync.containers.calendar.guide.webcal_warning_title',
    CALENDAR_GUIDE_WEBCAL_WARNING_MESSAGE: 'sync.containers.calendar.guide.webcal_warning_message',
    CALENDAR_GUIDE_COPY_LINK: 'sync.containers.calendar.guide.copy_link',
    CALENDAR_GUIDE_STEP_COPY_LINK_LABEL: 'sync.containers.calendar.guide.step_copy_link_label',
    CALENDAR_GUIDE_STEP_OPEN_OUTLOOK_LABEL: 'sync.containers.calendar.guide.step_open_outlook_label',
    CALENDAR_GUIDE_STEP_OPEN_OUTLOOK_DESCRIPTION: 'sync.containers.calendar.guide.step_open_outlook_description',
    CALENDAR_GUIDE_STEP_PASTE_IMPORT_LABEL: 'sync.containers.calendar.guide.step_paste_import_label',
    CALENDAR_GUIDE_STEP_PASTE_IMPORT_DESCRIPTION: 'sync.containers.calendar.guide.step_paste_import_description',
    CALENDAR_GUIDE_STEP_PASTE_IMPORT_WEBCAL_WARNING: 'sync.containers.calendar.guide.step_paste_import_webcal_warning',
    CALENDAR_GUIDE_MUST: 'sync.containers.calendar.guide.must',
};

export default translationIds;
